import React, { useContext, useEffect, useState } from "react";
import { Button, IconButton } from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import { NotificationsNoneOutlined } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { instance } from "../utils/api";
import { useParams } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { AppContext } from "../App";

function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const Token = localStorage.getItem("Token")
    const userRole = localStorage.getItem("userRole")

    const { state, actions } = useContext(AppContext)

    // const [name, setName] = useState(''); 
    // const [phone, setPhone] = useState(''); 
    // const { agentId } = useParams();

    // useEffect(() => {
    //     async function fetchProfileData() {
    //         try {
    //             const response = await instance.get(`agents/${agentId}`); 
    //             const profileData = response.data;
    //             setName(profileData.name);
    //             setPhone(profileData.phone);
    //         } catch (error) {
    //             console.error('Error fetching profile data:', error);
    //         }
    //     }

    //     fetchProfileData();
    // }, [agentId]);

    const NavigateChangePassword = () => {
        navigate('/changepassword');
    }
    const NavigateLogin = () => {
        navigate('/');
    }
    const handleProfile = () => {
        navigate('/profile');
    }
    const handleLogout = () => {
        localStorage.removeItem("Token");
        localStorage.removeItem("ID");
        localStorage.removeItem("userRole");

        actions.setTriggerRefresh(prev => prev + 1)
        navigate('/');
    }
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const [anchorEl2, setAnchorEl2] = React.useState(null);
    const open2 = Boolean(anchorEl2);
    const handleClick2 = (event) => {
        setAnchorEl2(event.currentTarget);
    };
    const handleClose2 = () => {
        setAnchorEl2(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const cl = "app-layout-header";

    const [image, setImage] = useState(null);
    const ID = localStorage.getItem("ID");
    const [newImage, setNewImage] = useState(null);
    useEffect(() => {
        if (ID) {

            async function fetchProfileData() {
                try {
                    const response = await instance.get(`agents/${ID}`);

                    const updateData = response.data

                    setImage(updateData.image)
                    console.log(updateData.image)
                    console.log(updateData)
                } catch (error) {
                    console.error('Error fetching profile data:', error);
                }
            }

            fetchProfileData();
        }
    }, [ID]);
    const [notificationsData, setNotificationsData] = useState([]);

    const fetchNotificationData = async () => {
        try {
            const response = await instance.get(`agents/notification/list`,
                {
                    headers: {
                        'Accept': 'application/json',
                        Authorization: `Bearer ${Token}`,
                    }
                },
            );
            setNotificationsData(response.data)
            console.log(response.data)
        } catch (err) {

            console.log(err);
        }
    };

    useEffect(() => {

        fetchNotificationData();


        const intervalId = setInterval(() => {
            fetchNotificationData();
        }, 20000);


        return () => clearInterval(intervalId);
    }, []);

    const handleNotificationClick = async (notificationId) => {
        handleClose();
        try {

            await instance.put(`agents/notification/${notificationId}/read`, {

            });



        } catch (error) {
            console.error('Error marking notification as read:', error);
        }
    };

    const hasUnreadNotifications = notificationsData.some(notification => !notification.is_read);


    return (
        <>
            <div className={`${cl}`}>
                <div className={`${cl}__wrapper`}>
                    <div className={`${cl}__left`}>
                        <img className="app-logo" src="/images/vibhohcm-logo.svg" />
                        <ul className={`${cl}__menu`}>
                            <li className={`${cl}__menu--item`}>
                                <Link to="/dashboard">
                                    <Button variant="text" type="primary" className="menu-btn --dashboardactive">
                                        <img src='/images/icons/dashboard.svg' />
                                        <span className="app-header-btn-text">
                                            Dashboard
                                        </span>
                                    </Button>
                                </Link>
                            </li>
                            {userRole === 'admin' && (
                                <li className={`${cl}__menu--item`}>
                                    <Link to="/tickets">
                                        <Button variant="text" type="primary" className={`menu-btn ${location.pathname === '/tickets' ? '--ticketactive' : ''}`}>
                                            <img src='/images/icons/ticket.svg' />
                                            <span className="app-header-btn-text">
                                                Tickets
                                            </span>
                                        </Button>
                                    </Link>
                                </li>
                            )}
                            {userRole === 'admin' && (
                                <li className={`${cl}__menu--item`}>
                                    <Link to="/agents">
                                        <Button variant="text" type="primary" className="menu-btn --agentactive">
                                            <img src='/images/icons/call-center-operator.svg' />
                                            <span className="app-header-btn-text">
                                                Agents
                                            </span>
                                        </Button>
                                    </Link>
                                </li>
                            )}
                            {/* <li className={`${cl}__menu--item`}>
                                <Link to="/users">
                                    <Button variant="text" type="primary" className="menu-btn --useractive">
                                        <img src='/images/icons/group.svg' />
                                        <span className="app-header-btn-text">
                                            Users
                                        </span>
                                    </Button>
                                </Link>
                            </li> */}

                            {userRole === 'agent' && (
                                <li className={`${cl}__menu--item`}>
                                    <Link to="/mytickets">
                                        <Button variant="text" type="primary" className={`menu-btn ${location.pathname === '/mytickets' ? '--useractive' : ''}`}>
                                            <img src='/images/icons/group.svg' />
                                            <span className="app-header-btn-text">
                                                My Tickets
                                            </span>
                                        </Button>
                                    </Link>
                                </li>
                            )}

                        </ul>
                    </div>
                    <ul className={`${cl}__profile`}>
                        <li className={`${cl}__profile--item`}>
                            <IconButton aria-describedby={id} className="notification-btn" onClick={handleClick}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={512}
                                    height={512}
                                    viewBox="0 0 32 32"
                                >
                                    <path
                                        d="m28.07 22.66-1.71-2.46a2 2 0 0 1-.36-1.14V12a10 10 0 0 0-20 0v7.06a2 2 0 0 1-.36 1.14l-1.71 2.46A2 2 0 0 0 5.41 26h5.69a5 5 0 0 0 9.8 0h5.69a2 2 0 0 0 1.48-3.34zM16 28a3 3 0 0 1-2.82-2h5.64A3 3 0 0 1 16 28zM5.41 24a.81.81 0 0 0 .12-.14l1.75-2.52A4 4 0 0 0 8 19.06V12a8 8 0 0 1 16 0v7.06a4 4 0 0 0 .72 2.28l1.75 2.52a.81.81 0 0 0 .12.14z"
                                        data-name={28}
                                    />
                                </svg>
                                {hasUnreadNotifications && <span className="notification-btn-dot"></span>}
                            </IconButton>
                            <Popover
                                id={id}
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                            >
                                <ul className='notification-list'>
                                    {notificationsData.length === 0 ? (
                                        <p>No notifications</p>
                                    ) : (
                                        notificationsData.map((notification) => (
                                            <li key={notification.notification_id} className='notification-list-item' style={{ backgroundColor: notification.is_read ? 'transparent' : '#c5def5' }}>
                                                <NotificationsNoneOutlined />
                                                <span>
                                                    <Link to={`/ticketdetail/${notification.ticket_id}`} onClick={() => handleNotificationClick(notification.notification_id)}>
                                                        Ticket {notification.ticket_id}-
                                                        {notification.Assignee ? `${notification.Assignee.name}` : ''}&nbsp;
                                                        {notification.message}
                                                        <div style={{ color: "#0b50bb" }}>click to view the ticket</div>
                                                    </Link>
                                                </span>
                                            </li>
                                        ))
                                    )}

                                </ul>


                            </Popover>
                        </li>
                        <li className={`${cl}__profile--item`}>
                            <Button
                                id="basic-button"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick2}
                                className='profile-menu-btn'
                            >
                                <img className='profile-menu-btn-pic' src={image} />
                                <span className='profile-menu-btn-title'>{userRole}</span>
                                <img className='profile-menu-btn-arrow' src='/images/icons/down-arrow.svg' />

                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl2}
                                open={open2}
                                onClose={handleClose2}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={handleProfile} >Profile</MenuItem>
                                <MenuItem onClick={NavigateChangePassword}>Change Password</MenuItem>
                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                            </Menu>
                        </li>
                    </ul>
                </div>
            </div >
        </>
    )
}
export default Header;
